























import {
	computed,
	defineComponent,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import Checkbox from '@front-app/components/inputs/Checkbox.vue';
import EditorWrapper from '@front-app/components/layouts/form/EditorWrapper.vue';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import {
	isNotNoneRole,
	ALL_ROLES,
	PROFESSIONAL_ROLES,
	UserDetailRoleNoNone,
} from '@front-app/services/UserApi/UserModel';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: {
		Checkbox,
		EditorWrapper,
	},
	props: {
		isLoading: Boolean,
		isError: Boolean,
		isSuccess: Boolean,
		onlyShowProfessionalRoles: Boolean,
	},
	setup(props) {
		const { currentUser } = CurrentUserStore;

		const roles: Ref<UserDetailRoleNoNone[]> = ref([]);
		const availableRoles = computed(() => {
			if (props.onlyShowProfessionalRoles) {
				return ALL_ROLES.filter((role) => PROFESSIONAL_ROLES.includes(role));
			}
			return ALL_ROLES;
		});
		const numSelectedAvailableRoles = computed(() => availableRoles
			.value
			.filter((availableRole) => roles.value.includes(availableRole))
			.length);

		const toggleRole = (role: UserDetailRoleNoNone) => {
			if (roles.value.includes(role)) {
				roles.value = roles.value.filter((val) => val !== role);
			} else {
				roles.value = roles.value.concat(role);
			}
		};

		watch(() => currentUser.value.roles, (curr) => {
			// Some roles (eg: CSR) aren't supported in this UI, but will be persisted by the BE anyway
			roles.value = curr
				.filter(isNotNoneRole)
				.filter((r) => ALL_ROLES.includes(r));
		}, { immediate: true });

		return {
			availableRoles,
			numSelectedAvailableRoles,
			roles,
			toggleRole,
			Size,
		};
	},
});
